export const Stage = {
  LOCAL: "local",
  DEV: "dev",
  STAGING: "staging",
  PROD: "production",
};

export const AREA_OPTIONS = [
  { label: "Top Navigation", value: "top_navigation" },
  // { label: "Footer", value: "footer" },
];

export const DISPLAY_FEATURED_PRODUCT_OPTION = [
  { label: "08", value: 8 },
  { label: "12", value: 12 },
  { label: "16", value: 16 },
];

export const TERMS_AND_CONDITION = "Terms and Conditions"
export const PRIVACY_POLICY = 'Privacy Policy'


